import { atom } from "jotai";

import { TSettings } from "../../types/settings";

const settingsAtom = atom<TSettings | null>(null);

export { settingsAtom };
